import {FormattedMessage} from "react-intl";

export const wmsPriorityRule = {
    FIFO: 'first_in_first_out',
    RETAILER_ITEMS: 'retailers_most_item',
    PLACE_ITEMS: 'places_most_item'
}

export function getPriorityRulesForForm() {
    return [
        {
            value: 'first_in_first_out',
            label: <FormattedMessage id={"wms.priorityRules.fifo"}/>
        },
        {
            value: 'retailers_most_item',
            label: <FormattedMessage id={"wms.priorityRules.retailerMostItem"}/>
        },
        {
            value: 'places_most_item',
            label: <FormattedMessage id={'wms.priorityRules.placesMostItem'}/>
        }
    ]
}